interface InsectsIconProps {
  amount: number;
}

const InsectsIcon: React.FC<InsectsIconProps> = ({ amount = 0 }) => {
  return (
    <div className="d-flex align-items-center position-relative m-1">
      <button
        type="button"
        className="btn btn-sm btn-ghost-success btn-rounded custom-toggle active m-1 text-success"
        data-bs-toggle="button"
        title="Bait in trap"
        style={{ borderRadius: '50%' }}
      >
        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success">
          {amount}
        </span>
        <span className="icon-on fs-6 text-success">
          <i className="ri-bug-fill align-bottom" />
        </span>
        <span className="icon-off fs-6 text-success">
          <i className="ri-bug-fill align-bottom" />
        </span>
      </button>
    </div>
  );
};

export default InsectsIcon;
